// Safe storage wrapper that handles blocked localStorage in cross-origin iframes (iOS Safari)
const memoryStore = {};

function isLocalStorageAvailable() {
  try {
    const testKey = '__storage_test__';
    localStorage.setItem(testKey, '1');
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}

const useLocal = isLocalStorageAvailable();

export const safeStorage = {
  getItem(key) {
    if (useLocal) {
      try { return localStorage.getItem(key); } catch { return memoryStore[key] || null; }
    }
    return memoryStore[key] || null;
  },
  setItem(key, value) {
    memoryStore[key] = value;
    if (useLocal) {
      try { localStorage.setItem(key, value); } catch {}
    }
  },
  removeItem(key) {
    delete memoryStore[key];
    if (useLocal) {
      try { localStorage.removeItem(key); } catch {}
    }
  },
};
